import { render, staticRenderFns } from "./CardItemNew.vue?vue&type=template&id=1bfe0d7b&scoped=true&"
import script from "./CardItemNew.vue?vue&type=script&lang=js&"
export * from "./CardItemNew.vue?vue&type=script&lang=js&"
import style0 from "./CardItemNew.vue?vue&type=style&index=0&id=1bfe0d7b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe0d7b",
  null
  
)

export default component.exports